import { Grid } from "@mui/material";
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import ComprobantesCargaForm from "src/general_components/ComprobantesCargaForm";

export const ComprobantesCarga = () => {
  return (
    <Grid style={{ marginBottom: "50px", paddingTop: 10 }}>
      <PageHeaderCard title="Carga de Comprobantes" icon={<NoteAddIcon />} />
      <ComprobantesCargaForm />
    </Grid>
  );
};
